import { z } from 'zod';

var LearningTrackType = /* @__PURE__ */ ((LearningTrackType2) => {
  LearningTrackType2["ORIGINAL"] = "original";
  LearningTrackType2["TOURNAMENT"] = "tournament";
  return LearningTrackType2;
})(LearningTrackType || {});
var EnabledOrDisabledSwitchValues = /* @__PURE__ */ ((EnabledOrDisabledSwitchValues2) => {
  EnabledOrDisabledSwitchValues2["ENABLED"] = "ENABLED";
  EnabledOrDisabledSwitchValues2["DISABLED"] = "DISABLED";
  return EnabledOrDisabledSwitchValues2;
})(EnabledOrDisabledSwitchValues || {});
var YesOrNoSwitchValues = /* @__PURE__ */ ((YesOrNoSwitchValues2) => {
  YesOrNoSwitchValues2["YES"] = "yes";
  YesOrNoSwitchValues2["NO"] = "no";
  return YesOrNoSwitchValues2;
})(YesOrNoSwitchValues || {});
var TimerValues = /* @__PURE__ */ ((TimerValues2) => {
  TimerValues2["OFF"] = "off";
  TimerValues2["DEFAULT"] = "classic";
  TimerValues2["STRICT"] = "strict";
  return TimerValues2;
})(TimerValues || {});
var ShowAnswers2Values = /* @__PURE__ */ ((ShowAnswers2Values2) => {
  ShowAnswers2Values2["ALWAYS"] = "always";
  ShowAnswers2Values2["PARTIAL"] = "partial";
  ShowAnswers2Values2["NEVER"] = "never";
  return ShowAnswers2Values2;
})(ShowAnswers2Values || {});
var StudentQuizReview2 = /* @__PURE__ */ ((StudentQuizReview22) => {
  StudentQuizReview22["YES"] = "yes";
  StudentQuizReview22["NO"] = "no";
  StudentQuizReview22["QONLY"] = "qonly";
  return StudentQuizReview22;
})(StudentQuizReview2 || {});
const gameSettings = z.object({
  groupIds: z.array(z.string()).nullable(),
  jumble: z.boolean(),
  jumbleAnswers: z.boolean(),
  limitAttempts: z.number(),
  loginRequired: z.boolean(),
  memes: z.boolean(),
  showAnswers: z.boolean(),
  showAnswers_2: z.nativeEnum(ShowAnswers2Values),
  studentLeaderboard: z.boolean(),
  studentMusic: z.boolean(),
  studentQuizReview: z.boolean(),
  studentQuizReview_2: z.nativeEnum(StudentQuizReview2),
  timer: z.boolean(),
  timer_3: z.nativeEnum(TimerValues),
  redemption: z.nativeEnum(YesOrNoSwitchValues),
  powerups: z.nativeEnum(YesOrNoSwitchValues),
  nicknameGenerator: z.boolean(),
  extraLife: z.nativeEnum(EnabledOrDisabledSwitchValues),
  memeset: z.string().nullable(),
  studentLiveReactions: z.boolean().optional(),
  adaptive: z.boolean().optional(),
  allowIssues: z.boolean().or(z.string()).optional(),
  masteryMode: z.object({
    goal: z.number(),
    reattempts: z.string()
  }).nullable()
});
const courseGameSchema = z.object({
  eventId: z.string().nullable().optional(),
  trackId: z.string(),
  createdBy: z.string(),
  type: z.nativeEnum(LearningTrackType),
  scheduledAt: z.string().nullable(),
  expiry: z.number(),
  gameOptions: gameSettings,
  memeSet: z.string().nullable(),
  startAt: z.string().nullable(),
  trackOptions: z.object({
    attemptInSequence: z.boolean()
  }),
  name: z.string(),
  groupIds: z.array(z.string()).nullable(),
  assignedTo: z.record(z.string(), z.array(z.string())).optional()
});

export { LearningTrackType, courseGameSchema, gameSettings };
